export default __webpack_public_path__ + "static/media/cart-to-port.aa9cf1bb.png";